import React, {memo} from 'react'
import {Container} from 'semantic-ui-react'
import {AccountWarning, TopNav} from './shared'
import {withMeData, withPropsPresent} from '../hoc'
import {isAuthRoute} from '../util'


const _Console = (props) => {
  const location = props.location

  return (
    <Container style={{marginTop: '8em'}}>
      <TopNav {...props}/>
      {!isAuthRoute(location.pathname) && (<AccountWarning {...props}/>)}
      {props.children}
    </Container>
  )
}

let Console = (props) => {
  return <_Console {...props}/>
}

Console = withPropsPresent(Console, ['me'])
Console = withMeData(Console, 'Loading profile...', false)
Console = memo(Console)

export {_Console, Console}

export default Console